import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTranslation } from "../services"; // Importar la función para hacer la petición

// Thunk asíncrono para obtener los datos de translation desde la API
export const fetchTranslationData = createAsyncThunk("translation/fetchTranslationData", async ({ countryId = 1, env = "prod", lang = 'eng' }, { rejectWithValue }) => {
  try {
    const data = await fetchTranslation(countryId, env, lang); // Llama al servicio de la API
    return data;
  } catch (error) {
    return rejectWithValue(error.message); // Manejo de errores
  }
});

const translationSlice = createSlice({
  name: "translation",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTranslationData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTranslationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default translationSlice.reducer;
